module.exports = __webpack_public_path__ + "img/svg/background-about-us.55ce86189c6bb3e3a801259df49eaba5.svg";